import type { Theme } from '@mui/material/styles';

const styles = {
  header: { alignItems: 'center', px: 1, pt: 1, pb: 0.5 },
  headerSpacer: { display: 'inline-block', width: 32 },
  headerLabel: {
    flex: 1,
    textAlign: 'center',
    textTransform: 'capitalize',
    fontWeight: 500,
    cursor: 'pointer',
    userSelect: 'none',
  },
  yearHeaderLabel: {
    flex: 1,
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    userSelect: 'none',
  },
  yearViewRoot: {
    width: 299,
    height: 340,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  calendar: {
    width: 299,
    height: 340,
  },
  yearGrid: (theme: Theme) => ({
    flex: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    alignContent: 'space-around',
    rowGap: 1,
    '&:hover .selected:not(:hover)': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },
    '&:has(.year-button.Mui-disabled:hover) .selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  }),
  yearButton: (theme: Theme) => ({
    width: '89px',
    height: '35px',
    minWidth: 0,
    padding: 0,
    borderRadius: '4px',
    color: 'unset',
    backgroundColor: 'transparent',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 400,
    '&:hover:not(:disabled)': {
      color: theme.palette.common.white,
      background: theme.palette.primary.main,
      textDecoration: 'none',
    },
    '&:disabled, &:disabled:hover': {
      color: theme.palette.text.secondary,
      pointerEvents: 'auto',
      cursor: 'default',
      backgroundColor: 'transparent',
      textDecoration: 'none',
    },
  }),
  yearButtonSelected: (theme: Theme) => ({
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: 500,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  calendarIcon: { mr: 1, cursor: 'pointer', color: 'action.active' },
  popper: { zIndex: 1300 } as const,
  paper: { mt: 0.5 },
} as const;

export default styles;
